import React, { useRef } from "react";
import { X } from "lucide-react";
import { Drawer } from 'vaul';

export default function ImageViewModal({
  viewImage = '',
  setViewImage = () => {},
  activeModal = false,
  setActiveModal = () => {},
  previousScrollPosition = 0,
}) {
  const dropdownRef = useRef(null);
  
  const handleDrawerClose = () => {
    setActiveModal(false);
    setViewImage(null);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 small">
            <Drawer.Title className="sr-only">Image View</Drawer.Title>
            <Drawer.Description className="sr-only">View large image</Drawer.Description>
            {viewImage !== "" && (
              <div className="docpro_modal_wrap docpro_style_2">
                <div className="docpro_modal" style={{ maxWidth: '90%', backgroundColor: '#ffffff00' }}>
                  <button
                    type="button"
                    className="docpro_close_btn"
                    style={{ top: 0, right: '-25px', color: '#cbcbcb' }}
                    onClick={() => handleDrawerClose()}
                  >
                    <X />
                  </button>
                  <div className="docpro_deleteboxbox">
                    <div className="flex items-center" style={{ minHeight: '300px', justifyContent: 'center' }}>
                      <img src={`${viewImage}`} alt="Referral" />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
